import React from 'react';
import _ from 'lodash';

import {
  getPlace,
  getDivisionDoc
} from 'util/lifterHelper';

const PlaceCell = ({data, column, meet, style}) => {
  const lifter = data.lifter;
  if(data.row === 'header') {
    return (
      <div style={style} className="table-cell-inner">
        {column.label}
      </div>
    );
  } else if(data.row === 'title') {
    return (
      <div style={style} className="table-cell-inner" />
    );
  } else {
    if(lifter.divisions.length < 2) {
      style = {...style, fontSize: style.fontSize*1.3};
    }
    return (
      <div style={style} className="table-cell-inner">
        {
          _.map(lifter.divisions, (lifterDivision, index) => {
            let rowStyle = {
              paddingBottom: style.padding
            };

            if(!lifterDivision.divisionId) {
              return null;
            }

            const division = getDivisionDoc(lifterDivision.divisionId, meet);
            if(!division) {
              return null;
            }

            if(division.hideOnBoard) {
              return null;
            }

            if(index !== 0) {
              rowStyle = {
                ...rowStyle,
                paddingTop: style.padding
              };
            }

            return (
              <div key={`${lifterDivision.divisionId}-${index}`} style={rowStyle} className="cell-row">
                {getPlace(lifter, lifterDivision, meet) || <span>&nbsp;</span>}
              </div>
            );
          })
        }
      </div>
    );
  }
};

export default PlaceCell;
